import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import React, { useCallback, useEffect, useState } from "react";
import { Button, Form, InputGroup } from 'react-bootstrap';
import { ChevronDown, Search } from 'react-bootstrap-icons';
import { Link, useNavigate } from "react-router-dom";
import noImage from "../../assets/images/image-not-available.jpg";
import siteLogo from "../../assets/images/site_logo.svg";
import { useApp } from "../../context/AppContextProvider";
import { enviroment } from "../../enviroment";
import ApiService from "../../services/ApiService";
import { AppNotification } from "../../utils/helper";
import { CartAside } from "../CartAside/CartAside";
import { LoginPopup } from "../LoginPopup/LoginPopup";
import {
  AccountIcon,
  BackArrowIcon,
  CartIcon,
  LocationIcon,
  LogoutIcon2,
  MailIcon,
  MenuIcons,
  OrderIcon,
  SearchIcon,
  SupportIcon,
  UserIcon
} from "../siteIcons";
import styles from "./Header.module.css";

import { JsonLd } from "react-schemaorg";
import { useAppStore } from "../../store";
import { HeaderNavLoader } from "../Loader/Loader";

const ProductSuggestions = ({
  searchProd,
  searchProdList,
  setSearchProdList,
  setSearchProd,
  navigate,
  isMobile = false,
  searchLoading = false
}) => {
  return (
    <div
      className={`${styles.showSearchList} position-absolute d-inline-flex flex-column start-0 col-12 overflow-y-auto p-0`}
      style={{
        position: isMobile ? 'fixed' : 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        maxHeight: '300px',
        overflowY: 'auto'
      }}
    >
      {searchLoading ? (
        <>
          <span className={`${styles.searchRow} p-3 d-flex align-items-center gap-2`}>
            <div className="skeleton-loading" style={{
              width: "20px",
              height: "20px",
              borderRadius: "4px",
              backgroundColor: "#f0f0f0",
              animation: "pulse 1.5s infinite"
            }} />
            <div className="skeleton-loading" style={{
              flex: 1,
              height: "16px",
              borderRadius: "4px",
              backgroundColor: "#f0f0f0",
              animation: "pulse 1.5s infinite"
            }} />
          </span>
          <span className={`${styles.searchRow} p-3 d-flex align-items-center gap-2`}>
            <div className="skeleton-loading" style={{
              width: "20px",
              height: "20px",
              borderRadius: "4px",
              backgroundColor: "#f0f0f0",
              animation: "pulse 1.5s infinite"
            }} />
            <div className="skeleton-loading" style={{
              flex: 1,
              height: "16px",
              borderRadius: "4px",
              backgroundColor: "#f0f0f0",
              animation: "pulse 1.5s infinite"
            }} />
          </span>
          <span className={`${styles.searchRow} p-3 d-flex align-items-center gap-2`}>
            <div className="skeleton-loading" style={{
              width: "20px",
              height: "20px",
              borderRadius: "4px",
              backgroundColor: "#f0f0f0",
              animation: "pulse 1.5s infinite"
            }} />
            <div className="skeleton-loading" style={{
              flex: 1,
              height: "16px",
              borderRadius: "4px",
              backgroundColor: "#f0f0f0",
              animation: "pulse 1.5s infinite"
            }} />
          </span>
        </>
      ) : (
        searchProdList?.length > 0 ? (
          <>
            {searchProdList.map((item) => (
              <button
                type="button"
                className={`${styles.searchRow} p-2 text-truncate col-12 text-start border-0 bg-white`}
                key={item.product_id}
                onClick={() => {
                  setSearchProdList([]);
                  navigate(`/product/${item?.name_url}/${item?.product_id}`);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    setSearchProdList([]);
                    navigate(`/product/${item?.name_url}/${item?.product_id}`);
                  }
                }}
              >
                {item.name}
              </button>
            ))}
          </>
        ) : (
          <span className={`${styles.searchRow} p-3 text-center col-12`}>
            Sorry, we couldn't find any results matching your search.
          </span>
        )
      )}
    </div>
  );
};

export const Header = ({ setAsideOpen, asideOpen }) => {
  const appData = useApp();
  const [loading, setLoading] = useState(true);
  const navItems = useAppStore((state) => state.navItems);
  const setNavItems = useAppStore((state) => state.setNavItems);
  const setCategories = useAppStore((state) => state.setCategories);
  const [searchProd, setSearchProd] = useState("");
  const [searchProdList, setSearchProdList] = useState([]);
  const [loginPop, setLoginPop] = useState(false);
  const [accountOptn, setAccountOptn] = useState(false);
  const [cartPop, setCartPop] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const [hoveredItem, setHoveredItem] = useState([]);
  const [hoveredPosition, setHoveredPosition] = useState({});

  const [catHoveredItem, setCatHoveredItem] = useState([]);
  const [catHoveredPosition, setCatHoveredPosition] = useState({});

  const navigate = useNavigate();


  const setNoImage = (e) => {
    if (e.target) {
      e.target.src = noImage;
    }
  };

  const openAsideMenu = () => {
    if (asideOpen === true) {
      setAsideOpen(false);
    } else {
      setAsideOpen(true);
    }
  };

  const routeHome = () => {
    window.location.href = "/";
  };

  const openAccountDetail = () => {
    if (accountOptn === true) {
      setAccountOptn(false);
    } else {
      setAccountOptn(true);
    }
  };

  const userLoggedOut = () => {
    const emptyCartData = [];
    appData.setAppData({
      ...appData.appData,
      user: "",
      loggedIn: false,
      cartSaved: false,
      cartData: emptyCartData,
      cartCount: 0,
    });
    localStorage.setItem("cartData", JSON.stringify(emptyCartData));
    localStorage.removeItem("user");
    localStorage.removeItem("cartSaved");
    localStorage.removeItem("loggedIn");
    AppNotification(
      "Logged Out",
      "You have been successfully logged out.",
      "success"
    );
    navigate("/");
  };

  let prodTime = "";
  const searchShopProd = (event, val) => {
    setSearchProd(val);
    clearTimeout(prodTime);
    if (val.length > 2) {
      prodTime = setTimeout(() => {
        const payload = {
          store_id: Number.parseInt(enviroment.STORE_ID),
          keyword: val,
        };
        ApiService.storeSearch(payload)
          .then((res) => {
            if (res.message === "Fetch successfully.") {
              setSearchProdList(res.payload_searchAI);
            }
          })
          .catch((err) => { });
      }, 500);
    }
  };

  const openProductId = (prodId, name, id) => {
    setSearchProdList([]);
    setSearchProd(name);
    navigate(`/product/${prodId}`);
  };

  const handleKeyDown = (event) => {
    if (searchProd.length > 1 && event.code === "Enter") {
      const category = searchProd?.replaceAll("[^A-Za-z0-9]", "-");
      setSearchProdList([]);
      navigate(`/search-product/${category}`);
    }
  };

  useEffect(() => {
    if (searchProd === "") {
      setSearchProdList([]);
    }
  }, [searchProd]);

  useEffect(() => {
    const payload = {
      store_id: Number.parseInt(enviroment.STORE_ID),
    };
    ApiService.AllCategory(payload)
      .then((res) => {
        const allSubCategory = res?.payload_verticalWithCatList?.vertical;
        const allCatList = allSubCategory.flatMap((item) => {
          if (item?.catList?.length > 0) {
            return item.catList.map((catItem) => ({
              verticalSlug: item.name_url,
              category: catItem,
            }));
          }
          return [];
        });
        setNavItems(allSubCategory);
        setCategories(allCatList);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [setCategories, setNavItems]);

  useEffect(() => {
    setUserInfo(appData.appData.user);
  }, [appData?.appData]);

  const handleMouseEnter = (item, index) => {
    // if index is smae then set hoveredItem to null
    if (hoveredItem === item) {
      return handleMouseLeave();
    }
    const element = document.getElementById(`menu-${index}`);
    setHoveredItem(item);
    const pos = element.getBoundingClientRect();

    if (catHoveredItem) {
      if (catHoveredItem?.category_id !== hoveredItem?.category_id) {
        setCatHoveredItem(null)
      }
    }

    setHoveredPosition({
      left: `${[pos.left]}px`,
    });
  };

  const handleMouseLeave = useCallback(() => {
    setHoveredItem(null);
    setHoveredPosition({});
    setCatHoveredItem(null);
    setCatHoveredPosition({});
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleMouseLeave);
    return () => {
      document.removeEventListener("click", handleMouseLeave);
    };
  }, [handleMouseLeave]);
  //   Televisions
  // Refrigerator
  // Washing Machines
  // Air Care
  // Home Appliances
  // Lifestyle
  // Mobiles & Laptops

  const getCatIcon = (catName) => {
    switch (catName) {
      case "Televisions":
        return "/images/tv.svg";
      case "Refrigerator":
        return "/images/fridge.svg";
      case "Washing Machines":
        return "/images/washing-machine.svg";
      case "Air Care":
        return "/images/air-conditioner.svg";
      case "Home Appliances":
        return "/images/old-television.svg";
      case "Lifestyle":
        return "/images/cycle.svg";
      case "Mobiles & Laptops":
        return "/images/laptop-webcam.svg";
      case "Sound systems":
        return "/images/speakers.svg";
      default:
        return "/images/tv.svg";
    }
  }

  return (
    <>
      {/* Site Navigation Schema */}
      {navItems.length > 0 && (
        <JsonLd
          item={{
            "@context": "https://schema.org",
            "@type": "ItemList",
            name: "Main Navigation",
            description: "Main navigation menu for the website",
            url: window.location.href,
            itemListElement: navItems.map((item, index) => ({
              "@type": "ListItem",
              position: index + 1,
              item: {
                "@type": "SiteNavigationElement",
                name: item.name,
                url: `${window.location.origin}/store/${item.name_url}`,
              },
            })),
          }}
        />
      )}

      {/* Search Action Schema (unchanged) */}
      <JsonLd
        item={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          url: window.location.origin,
          potentialAction: {
            "@type": "SearchAction",
            target: `${window.location.origin}/search-product/{search_term_string}`,
            "query-input": "required name=search_term_string",
          },
          name: enviroment.REACT_APP_BUSINESS_NAME || "Store",
        }}
      />

      {/* Mobile Structure */}
      <div
        className={"hideInDesktop"}
        style={{
          position: searchProdList?.length > 0 ? 'fixed' : 'relative',
          minHeight: 'fit-content',
          width: '100%',
          top: 0,
          left: 0,
          zIndex: 1000,
        }}
      >
        <div className={`${styles.siteHeader} col-12`}>
          {searchProdList?.length > 0 ? (
            // Show this when search results are present
            <div className="d-flex align-items-center gap-2 p-3">
              <button
                type="button"
                className="btn p-0"
                onClick={() => {
                  setSearchProdList([]);
                  setSearchProd("");
                }}
              >
                <BackArrowIcon color="black" />
              </button>
              <div className="position-relative flex-grow-1">
                <span className={`${styles.searchIcon} position-absolute p-1 top-0 bottom-0 m-auto start-0 ms-3 d-inline-flex align-items-center`}>
                  <SearchIcon color="#000" />
                </span>
                <input
                  type="text"
                  className={`${styles.inputSearch} d-inline-flex ps-5 col-12 p-3 pe-3`}
                  style={{
                    fontSize: '1rem',
                  }}
                  value={searchProd}
                  onChange={(e) => searchShopProd(e, e.target.value)}
                  placeholder={enviroment.SEARCH_PLACEHOLDER}
                  onKeyDown={handleKeyDown}
                />
                <ProductSuggestions
                  searchProd={searchProd}
                  searchProdList={searchProdList}
                  setSearchProdList={setSearchProdList}
                  setSearchProd={setSearchProd}
                  navigate={navigate}
                />
              </div>
            </div>
          ) : (
            // Original header when no search results
            <>
              <div className="d-inline-flex col-12">
                <div
                  className={`${styles.menuIconBox} d-inline-flex align-items-center ms-3 justify-content-center`}
                  onClick={openAsideMenu}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      openAsideMenu()
                    }
                  }}
                >
                  <MenuIcons color={'black'} />
                </div>
                <h1
                  onClick={() => routeHome()}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      routeHome()
                    }
                  }}
                  style={{ cursor: "pointer" }}
                  itemtype="http://schema.org/Organization"
                  className={`${styles.siteLogoBox} w-100 d-flex justify-content-center position-relative`}
                >
                  <span class="visually-hidden">
                    {enviroment.REACT_APP_BUSINESS_NAME}
                  </span>
                  <img
                    src={siteLogo}
                    alt={enviroment.REACT_APP_BUSINESS_NAME ?? 'Logo'}
                    style={{
                      maxWidth: '220px',
                      maxHeight: '35px',
                    }}
                  />
                </h1>
                <div className="d-inline-flex align-items-stretch justify-content-end gap-2 me-4">
                  <Link
                    to="checkout"
                    className={`${styles.supportDrop} d-inline-flex d-inline-flex align-items-center gap-2 position-relative`}
                  >
                    <div className="position-relative d-inline-flex">
                      <CartIcon color="#000" />
                      {appData?.appData?.cartCount > 0 && (
                        <span
                          className={`${styles.cartCount} position-absolute d-inline-flex align-items-center`}
                        >
                          {appData?.appData?.cartCount}
                        </span>
                      )}
                    </div>
                  </Link>
                </div>
              </div>
              <div className={"d-inline-flex align-items-center pt-3 w-100"}>
                <div className="position-relative" style={{
                  width: "92%",
                  margin: "auto",
                }}>
                  <span
                    className={`${styles.searchIcon} position-absolute p-1 top-0 bottom-0 m-auto start-0 ms-3 d-inline-flex align-items-center`}
                  >
                    <SearchIcon color="#000" />
                  </span>
                  <input
                    type="text"
                    className={`${styles.inputSearch} d-inline-flex ps-5 col-12 p-3 pe-3`}
                    style={{
                      fontSize: '1rem',
                    }}
                    value={searchProd}
                    onChange={(e) => searchShopProd(e, e.target.value)}
                    placeholder={enviroment.SEARCH_PLACEHOLDER}
                    onKeyDown={handleKeyDown}
                  />
                </div>
              </div>
            </>
          )}
        </div>
        {/* {searchProdList?.length > 0 && (
          <ProductSuggestions
            searchProd={searchProd}
            searchProdList={searchProdList}
            setSearchProdList={setSearchProdList}
            setSearchProd={setSearchProd}
            navigate={navigate}
            isMobile={true}
          />
        )} */}
      </div>
      {/* Delivering India Section */}
      <div
        className={`${styles.topHeaderSale} hideInMobile col-12 owl-theme`}>
        <div
          className={`col-12 ${styles.dealsLinkWrapper} d-inline-flex align-items-center justify-content-center h-100`}
        >
          <span
            className={`d-inline-block text-decoration-none ${styles.dealsLink}`}
            title="Superdeals"
          >
            Shop Smart, Save Big! Explore Our Open-Box Collection Today!
          </span>
        </div>
      </div>

      {/* Desktop Structure */}
      <div className={"hideInMobile col-12 d-inline-flex flex-column"} style={{
        position: 'sticky',
        top: '0',
        zIndex: '999',
        backgroundColor: 'white',
      }}>
        <div
          className={`${styles.headerRow} col-12 d-inline-flex w-100`}>
          <div className="h-100 container-fluid d-flex p-0" style={{
            position: 'relative',
            width: '100vw',

          }}>
            <div
              className={"p-0 m-0 h-100 mx-auto col-12 d-flex gap-3"}
              style={{
                maxWidth: "1400px",
                margin: "auto"
              }}
            >
              <div className="col-8  row">
                <div className="col-4 d-flex justify-content-center align-items-center">
                  <h1
                    onClick={() => routeHome()}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        routeHome()
                      }
                    }}
                    itemtype="http://schema.org/Organization"
                    style={{
                      cursor: "pointer",
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      maxWidth: 'calc(100% - 4rem)',
                      maxHeight: '50px',
                      transform: 'translateY(-20%)',
                    }}
                    className="m-0 d-inline-flex justify-content-start col-2 ms-5 ps-5 w-100"
                  >
                    <span className="visually-hidden">
                      {enviroment.REACT_APP_BUSINESS_NAME}
                    </span>
                    <img
                      src={siteLogo}
                      alt={enviroment.REACT_APP_BUSINESS_NAME ?? 'Logo'}
                      className="object-fit-contain mt-3"
                    />
                  </h1>
                </div>
                <div className="col-8 d-flex justify-content-center align-items-center">
                  <SearchElement
                    searchProd={searchProd}
                    searchShopProd={searchShopProd}
                    handleKeyDown={handleKeyDown}
                    setIsSearchOpen={setIsSearchOpen}
                    searchProdList={searchProdList}
                    openProductId={openProductId}
                    setSearchProd={setSearchProd}
                    setSearchProdList={setSearchProdList}
                    navigate={navigate}
                  />
                </div>
              </div>
              <div className="d-flex align-items-stretch justify-content-end gap-2 pe-5 col-4">
                <div
                  className={`${styles.supportDrop} d-inline-flex d-inline-flex align-items-center gap-2 position-relative`}
                >
                  <div className={`p-2 btn ${styles.navItem}`}>
                    <SupportIcon color="#000" />
                    <span className={`${styles.supportHideOnMobile}`}>
                      Support
                    </span>
                  </div>
                  <div
                    className={`${styles.supportDropDown} position-absolute d-inline-block`}
                  >
                    <div
                      className={`${styles.timingPhoneBox} d-inline-flex col-12 align-items-center gap-3`}
                    >
                      <SupportIcon color="#000" />
                      <div className="d-inline-flex flex-column">
                        <label
                          htmlFor="supportTimings"
                          className={`${styles.supportTimings} d-inline-block col-12 p-0 text-center`}
                        >
                          7 days, 9AM to 9PM
                        </label>
                        <Link
                          to={`tel:${enviroment.PHONE_NUMBER}`}
                          style={{
                            textDecoration: "none",
                          }}
                          className={`${styles.supportPhoneNumber} text-decoration-none d-inline-block col-12 p-0 text-center`}
                        >
                          {enviroment.PHONE_NUMBER}
                        </Link>
                      </div>
                    </div>
                    <div
                      className={`${styles.mailtoBox} text-decoration-none d-inline-flex align-items-center gap-3 col-12`}
                    >
                      <MailIcon color="#000" />
                      <Link
                        to={`mailto:${enviroment.EMAIL_ADDRESS}`}
                        className={`${styles.mailtoEmail} d-inline-block text-decoration-none`}
                      >
                        {enviroment.EMAIL_ADDRESS}
                      </Link>
                    </div>
                    <div
                      className={`${styles.orderTrackLinks} d-none justify-content-between align-items-center col-12 p-0`}
                    >
                      <Link
                        className={`${styles.supportLinks} text-decoration-none d-inline-flex`}
                      >
                        Chat With Us
                      </Link>
                      <span className={`${styles.dotSymbol} d-inline-flex`}>
                        &bull;
                      </span>
                      <Link
                        className={`${styles.supportLinks} text-decoration-none d-inline-flex`}
                      >
                        FAQ&apos;s
                      </Link>
                      <span className={`${styles.dotSymbol} d-inline-flex`}>
                        &bull;
                      </span>
                      <Link
                        className={`${styles.supportLinks} text-decoration-none d-inline-flex`}
                      >
                        Track Order
                      </Link>
                    </div>
                  </div>
                </div>
                {(userInfo?.customer_id) ? (
                  <div
                    className={`${styles.supportDrop} d-inline-flex flex-column align-items-center gap-1 position-relative justify-content-center`}
                    onMouseEnter={() => openAccountDetail()}
                    onMouseLeave={() => openAccountDetail()}
                  >
                    <div className={`p-2 btn ${styles.navItem}`}>
                      <div className="d-inline-flex align-items-center gap-2">
                        <UserIcon color="#000" />
                      </div>
                      {userInfo?.name && userInfo?.name !== "" ? (
                        <span className={"d-inline-flex"}>
                          {userInfo.name}
                        </span>
                      ) : (
                        <span className={"d-inline-flex"}>
                          My Account
                        </span>
                      )}
                    </div>
                    {accountOptn === true && (
                      <div
                        className={`${styles.userAccountDrop} position-absolute col-12`}
                        onClick={(e) => e.preventDefault()}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            navigate("/my-account")
                          }
                        }}
                      >
                        <span
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              navigate("/my-account")
                            }
                          }}
                          className={`${styles.accountOption} ${styles.navItem} col-12 d-inline-flex align-items-center`}
                          onClick={() => navigate("/my-account")}
                        >
                          <AccountIcon />
                          My Account
                        </span>
                        <span
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              navigate("/my-orders")
                            }
                          }}
                          className={`${styles.accountOption} ${styles.navItem} col-12 d-inline-flex align-items-center`}
                          onClick={() => navigate("/my-orders")}
                        >
                          <OrderIcon color={'black'} />
                          My Orders
                        </span>
                        <span
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              navigate("/my-address")
                            }
                          }}
                          className={`${styles.accountOption} ${styles.navItem} col-12 d-inline-flex align-items-center`}
                          onClick={() => navigate("/my-address")}
                        >
                          <LocationIcon />
                          My Address
                        </span>
                        <span
                          onClick={() => userLoggedOut()}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              userLoggedOut()
                            }
                          }}
                          className={`${styles.accountOption} ${styles.navItem} col-12 d-inline-flex align-items-center`}
                        >
                          <LogoutIcon2 />
                          Log Out
                        </span>
                      </div>
                    )}
                  </div>
                ) : (
                  <div
                    className={`${styles.supportDrop} d-inline-flex d-inline-flex align-items-center gap-2 position-relative`}
                    onClick={() => setLoginPop(true)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        setLoginPop(true)
                      }
                    }}
                  >
                    <div className={`p-2 btn ${styles.navItem}`}>
                      <UserIcon color="#000" />
                      <span className={`${styles.supportHideOnMobile}`}>
                        Account
                      </span>
                    </div>
                  </div>
                )}
                <div
                  className={`${styles.supportDrop} me-5 d-inline-flex d-inline-flex align-items-center gap-2 position-relative`}
                  onClick={() => setCartPop(true)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      setCartPop(true)
                    }
                  }}
                >
                  <div className={`p-2 btn ${styles.navItem}`}>
                    <span className="position-relative d-inline-flex gap-2">
                      <CartIcon color="#000" />
                      <span className={`${styles.supportHideOnMobile}`}>
                        Cart
                      </span>
                      {appData?.appData?.cartCount > 0 && (
                        <span
                          className={`${styles.cartCount} position-absolute d-inline-flex align-items-center`}
                        >
                          {appData?.appData?.cartCount}
                        </span>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {loginPop === true && <LoginPopup setLoginPop={setLoginPop} />}
        {cartPop === true && <CartAside setCartPop={setCartPop} />}
      </div >

      {/* if location is / then show big category else small category */}
      {window.location.pathname !== "/" ? (
        <HeaderCategorySmall
          loading={loading}
          navItems={navItems}
          handleMouseEnter={handleMouseEnter}
          handleMouseLeave={handleMouseLeave}
          hoveredItem={hoveredItem}
          hoveredPosition={hoveredPosition}
          setHoveredItem={setHoveredItem}
          setCatHoveredItem={setCatHoveredItem}
          catHoveredItem={catHoveredItem}
          getCatIcon={getCatIcon}
        />
      ) : (
        <HeaderCategoryBig
          loading={loading}
          navItems={navItems}
          handleMouseEnter={handleMouseEnter}
          handleMouseLeave={handleMouseLeave}
          hoveredItem={hoveredItem}
          hoveredPosition={hoveredPosition}
          setHoveredItem={setHoveredItem}
          setNoImage={setNoImage}
          isSearchOpen={isSearchOpen}
          searchProd={searchProd}
          searchProdList={searchProdList}
          setSearchProdList={setSearchProdList}
          setSearchProd={setSearchProd}
          navigate={navigate}
          catHoveredItem={catHoveredItem}
          setCatHoveredItem={setCatHoveredItem}
        />
      )}
    </>
  );
};

const HeaderCategorySmall = ({
  loading,
  navItems,
  handleMouseEnter,
  handleMouseLeave,
  hoveredItem,
  hoveredPosition,
  setHoveredItem,
  setCatHoveredItem,
  catHoveredItem,
  getCatIcon
}) => {
  return (
    <div
      className={`${styles.headerNavList} w-100 position-relative`}
    >
      <div className="px-5">
        {loading ? (
          <HeaderNavLoader />
        ) : (
          <div
            className={`${styles.headerMenuRow} w-100 col-12`}
          >
            {navItems.length > 0 &&
              <div className={`${styles.headerMenuItems}`}>
                {navItems?.map((item, index) => (
                  <div
                    id={`menu-${index}`}
                    className={`${styles.headerNavBox} position-relative d-inline-flex align-items-center`}
                    key={item?.name_url}
                    onMouseEnter={() => handleMouseEnter(item, index)}
                    onClick={() => handleMouseEnter(item, index)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleMouseEnter(item, index)
                      }
                    }}
                  >
                    <a
                      href={`/store/${item.name_url}`}
                      className={`${styles.menuName} py-1`}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minWidth: 'fit-content',
                        gap: '0.5rem',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        fontSize: '1rem',
                        textDecoration: 'none',
                      }}
                    >
                      <span
                        className={`${styles.menuNameText}`}
                        style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          display: 'inline-block',
                          verticalAlign: 'middle',
                        }}
                      >
                        <span className="text-dark">{item.name}</span>
                        {
                          item?.catList?.length > 0 ? (
                            <span className="ps-2">
                              <ChevronDown size={30} style={{
                                height: "15px",
                                width: "15px",
                                transition: "all 0.3s ease",
                                rotate:
                                  hoveredItem?.name_url === item?.name_url ?
                                    "270deg" :
                                    "90deg",
                              }} />
                            </span>
                          ) : null
                        }
                      </span>
                    </a>
                  </div>
                ))}
                <HoveredItemsList
                  hoveredItem={hoveredItem}
                  hoveredPosition={hoveredPosition}
                  setHoveredItem={setHoveredItem}
                  handleMouseLeave={handleMouseLeave}
                  catHoveredItem={catHoveredItem}
                  setCatHoveredItem={setCatHoveredItem}
                />
              </div>
            }
          </div>
        )}
      </div>
    </div>
  )
}

export const HeaderCategoryBig = ({
  loading,
  navItems,
  handleMouseEnter,
  handleMouseLeave,
  hoveredItem,
  hoveredPosition,
  setHoveredItem,
  setNoImage,
  isSearchOpen,
  searchProd,
  searchProdList,
  setSearchProdList,
  setSearchProd,
  navigate,
  catHoveredItem,
  setCatHoveredItem
}) => {
  return (
    <div
      className={`${styles.headerNavList} rounded hideInMobile py-3 position-relative`}
    >
      <div style={{
        width: 'fit-content',
        margin: '0 auto',
      }}>
        {loading ? (
          <HeaderNavLoader />
        ) : (
          <div
            className={`${styles.headerMenuRow} col-12`}
          >
            {navItems.length > 0 &&
              <div className={`${styles.headerMenuItems}`}>
                {navItems?.map((item, index) => (
                  <div
                    id={`menu-${index}`}
                    className={`${styles.headerNavBox} position-relative d-inline-flex flex-column align-items-center`}
                    key={item?.name_url}
                    onMouseEnter={() => handleMouseEnter(item, index)}
                    onClick={() => handleMouseEnter(item, index)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleMouseEnter(item, index)
                      }
                    }}
                  >
                    <a
                      href={`/store/${item.name_url}`}
                      className={`${styles.menuName}`}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        minWidth: 'fit-content',
                        borderRadius: "5px",
                        height: "100px",
                        width: "100px",
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        fontSize: '1rem',
                        textDecoration: 'none',
                        border:
                          hoveredItem?.name_url === item?.name_url ?
                            '1px solid var(--ADD_BUTTON_COLOR)' :
                            'none',
                        backgroundColor: 'white',
                        padding: hoveredItem?.name_url === item?.name_url ? '20px' : '10px',
                        transition: 'all 0.3s ease',
                      }}
                    >
                      <img src={item?.image}
                        // fallback
                        onError={(e) => {
                          setNoImage(e);
                        }}
                        alt={item.name} style={{
                          objectFit: 'contain',
                          height: '100%',
                          width: '100%',
                        }} />
                    </a>
                    <span
                      className={`${styles.menuNameText}`}
                      style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        display: 'inline-block',
                        verticalAlign: 'middle',
                        fontSize: '0.8rem',
                        fontWeight: 'bold',
                        color:
                          hoveredItem?.name_url === item?.name_url ?
                            'var(--ADD_BUTTON_COLOR)' :
                            'var(--PRIMARY_COLOR)',
                      }}
                    >
                      {item.name}
                    </span>
                  </div>
                ))}
                <HoveredItemsList
                  hoveredItem={hoveredItem}
                  hoveredPosition={hoveredPosition}
                  setHoveredItem={setHoveredItem}
                  handleMouseLeave={handleMouseLeave}
                  catHoveredItem={catHoveredItem}
                  setCatHoveredItem={setCatHoveredItem}
                />
              </div>
            }
          </div>
        )}
      </div>
      {/* {
        isSearchOpen && (
          <ProductSuggestions
            searchProd={searchProd}
            searchProdList={searchProdList}
            setSearchProdList={setSearchProdList}
            setSearchProd={setSearchProd}
            navigate={navigate}
          />
        )} */}
    </div>
  )
}

const SearchElement = ({
  searchProd,
  searchShopProd,
  handleKeyDown,
  setIsSearchOpen,
  searchProdList,
  openProductId,
  setSearchProdList,
  setSearchProd,
  navigate
}) => {
  return (
    <>
      <div
        className={"d-inline-flex w-100 col-10 position-relative align-items-center"}
      >
        <InputGroup>
          <Form.Control
            type="search"
            value={searchProd}
            onChange={(e) => searchShopProd(e, e.target.value)}
            placeholder="What are you looking for?"
            onKeyDown={handleKeyDown}
            onFocus={() => setIsSearchOpen(false)}
            onBlur={() => setTimeout(() => setIsSearchOpen(false), 200)}
            className={styles.searchInput}
          />
          <Button variant="outline-secondary" className={`${styles.searchButton} text-white`}>
            <Search />
          </Button>
        </InputGroup>
        {searchProdList?.length > 0 && (
          <ProductSuggestions
            searchProd={searchProd}
            searchProdList={searchProdList}
            setSearchProdList={setSearchProdList}
            setSearchProd={setSearchProd}
            navigate={navigate}
          />
        )}
      </div>
    </>
  );
};

const HoveredItemsList = ({
  hoveredItem,
  hoveredPosition,
  setHoveredItem,
  handleMouseLeave,
  catHoveredItem,
  setCatHoveredItem
}) => {
  return (
    <>
      {hoveredItem?.catList?.length > 0 && (
        <div
          className={`${styles.SubMenuList} bg-white shadow-lg border`}
          style={{
            position: 'absolute',
            left: hoveredPosition.left,
            zIndex: 100,
            minWidth: '220px',
            maxWidth: '800px',
            display: 'flex',
            top: '100%'
          }}
          onMouseEnter={() => setHoveredItem(hoveredItem)}
          onMouseLeave={handleMouseLeave}
        >
          {/* Category List */}
          <div className="category-list" style={{
            borderRight: '1px solid #eee',
            minWidth: '220px'
          }}>
            {hoveredItem?.catList?.map((subNme) => (
              <div
                key={subNme?.category_id}
                className={`category-item ${styles.categoryItem}`}
                onMouseEnter={() => {
                  if (subNme?.subcatList?.length === 1 && subNme.name === subNme?.subcatList[0].name) {
                    const subItemWithRemovedSubcat = {
                      ...subNme,
                      subcatList: []
                    }
                    setCatHoveredItem(subItemWithRemovedSubcat)
                  } else {
                    setCatHoveredItem(subNme)
                  }
                }}
                style={{
                  padding: '12px 20px',
                  cursor: 'pointer',
                  fontWeight: catHoveredItem?.category_id === subNme?.category_id ? 'bold' : 'normal',
                  transition: 'all 0.3s ease',
                }}
              >
                <Link
                  to={`/store-product/${subNme?.name_url}`}
                  className="d-flex justify-content-between align-items-center text-dark text-decoration-none"
                >
                  <span style={{
                    color: catHoveredItem?.category_id === subNme?.category_id ? 'var(--ADD_BUTTON_COLOR)' : 'var(--PRIMARY_COLOR)'
                  }}>{subNme.name}</span>
                  {subNme?.subcatList?.length > 0 && (
                    <i className="fas fa-chevron-right" />
                  )}
                </Link>
              </div>
            ))}
          </div>

          {/* Subcategories Panel */}
          {catHoveredItem?.subcatList?.length > 0 && (
            <div className="subcategories p-3" style={{
              minWidth: '220px',
              backgroundColor: '#f9f9f9'
            }}>
              <div className="d-flex flex-column gap-2">
                {catHoveredItem.subcatList.map((subCat) => (
                  <Link
                    key={subCat.subcategory_id}
                    to={`/category/${catHoveredItem?.name_url}/sub-category/${subCat?.name_url}`}
                    className={`text-secondary p-2 text-decoration-none ${styles.subCategoryItem}`}
                    style={{
                      transition: 'all 0.3s ease',
                    }}
                  >
                    <span tyle={{
                      transition: 'all 0.3s ease',
                    }}>{subCat.name}</span>
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};